import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Grid2 } from '@mui/material';
import SkeletonCard from '../components/skeletonCard';
import theme from '../theme';
import { t } from 'i18next';


const TimeSlotsComponent = ({ schedules, availableSlotTimeList, handleSlotSelect, isLoading, bookingDetails, isStoreClosed}) => {
  const [scheduleData, setScheduleData] = useState([]);
  const [selectedAvailableSlot, setSelectedAvailableSlot] = useState(null);

  useEffect(()=>{
    setSelectedAvailableSlot(bookingDetails?.selectedSlot)
  },[bookingDetails])

  useEffect(() => {
    if (availableSlotTimeList && availableSlotTimeList.length > 0) {
      // Group available slots by hour
      const groupedSlots = availableSlotTimeList.reduce((acc, timeSlot) => {
        const hour = parseInt(timeSlot.split(':')[0], 10);
        
        if (!acc[hour]) {
          acc[hour] = {
            title: `${hour}`,
            data: []
          };
        }
        acc[hour].data.push(timeSlot);
        return acc;
      }, {});

      // Convert to array and sort by hour
      const sortedSchedules = Object.values(groupedSlots).sort((a, b) => {
        return parseInt(a.title) - parseInt(b.title);
      });

      setScheduleData(sortedSchedules);
    } else {
      setScheduleData([]);
    }
  }, [availableSlotTimeList]);

  const TimeSlotsGrid=({data})=>{
    const renderTimeSlot = ({ item, index }) => {
      if (!item) return null;
      
      const isSelected = selectedAvailableSlot && selectedAvailableSlot.split(' - ')[0] === item;
      
      return (
        <Grid2 item size = {{xs:2, md:2}} key={index} sx={{ 
          display: 'flex', 
          justifyContent: 'center',  
          fontWeight: 'bold',
          backgroundColor: isSelected ? '#F7BD98' : 'white', 
          fontSize: '7px', 
          height: {xs:50, md: 50}, 
          borderRadius: '15px', 
          border:`1px solid ${theme.palette.primary.divider}` 
        }}>
          <Button
            onClick={() => {
              setSelectedAvailableSlot(item);
              handleSlotSelect(item);
            }}
            sx={{ 
              color: isSelected ? 'white' : 'black',
              fontSize:'0.75rem'
            }}
          >
            {item}
          </Button>
        </Grid2>
      );
    };

    return (
      <Grid2 container spacing={{xs: 1, md:2 }} size={{md:12,xs:12}}>
        {data.map((item,index)=>renderTimeSlot({item, index}))}
      </Grid2>
    );
  }

  return (
    <Box sx={{ width: '100%', height: '300px', overflowY: 'auto',  pl:2, pr:2 , pt:{xs:1}, pb:{xs:2}, minWidth:{xs:300, md:400}}} justifyContent={'center'} alignItems={'center'}>
      {isStoreClosed ? (
        <Typography variant='body1' sx={{color:'text.secondary', px:4, display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
          {t('employee_is_not_available')}
        </Typography>
      ) : isLoading ? (
        <SkeletonCard />
      ) : scheduleData.length > 0 ? (
        scheduleData.map((scheduleDataObj, index) => (
          <React.Fragment key={index}>
            <Typography style={{ color: 'black', marginBottom: 5, padding:10, pl : {xs:0,md:10} }}>
              {scheduleDataObj.title}
            </Typography>
            <TimeSlotsGrid data={scheduleDataObj?.data} title={scheduleDataObj?.title}/>       
          </React.Fragment>
        ))
      ) : (
        <Typography variant='body1' sx={{color:'text.secondary', px:4, display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center'}}>
          {t('slot_is_not_available')}
        </Typography>
      )}
    </Box>
  );
};

export default TimeSlotsComponent;
